module.exports = __webpack_public_path__ + "static/img/banner06.a7bba42e.png";